import compact from 'lodash/compact';
import { useMemo } from 'react';

import { ActionBar, TaskIcon } from '@dreryk/react-components';
import { useDraftCqrsSearch } from '@dreryk/react-draft';

import { consentTemplateActionTranslationKeys } from '../../../translations';
import { getConsentTemplateDraftTag, getTemplateDraftId } from '../../visit.draft';
import { VisitActionBarOrder } from '../VisitActionBar';

import { ConsentTemplateActionBadge } from './ConsentTemplateAction.badge';
import { useConsentTemplateRouteMatch } from './ConsentTemplateAction.hooks';
import { ConsentTemplateModalOpener } from './modal/ConsentTemplateModal.opener';

type ConsentTemplateActionProps = {
   readonly patientId: number;
   readonly visitId: number;
};

export const ConsentTemplateAction = (props: ConsentTemplateActionProps): JSX.Element => {
   const { data: documentTemplateDrafts, refetch: refetchConsentTemplateDrafts } = useDraftCqrsSearch({
      tag: getConsentTemplateDraftTag(props.visitId),
   });

   const priorityTemplateIds = useMemo<number[]>(() => {
      return compact(documentTemplateDrafts?.map((draft) => getTemplateDraftId(draft.token)));
   }, [documentTemplateDrafts]);

   const numberOfDrafts = documentTemplateDrafts?.length ?? 0;

   useConsentTemplateRouteMatch({
      onLeave: refetchConsentTemplateDrafts,
   });

   return (
      <ConsentTemplateModalOpener
         patientId={props.patientId}
         visitId={props.visitId}
         priorityTemplateIds={priorityTemplateIds}
      >
         {({ openModal }) => (
            <ActionBar.OptionalLink
               testId={'consentTemplates'}
               icon={
                  <ConsentTemplateActionBadge numberOfDrafts={numberOfDrafts}>
                     <TaskIcon />
                  </ConsentTemplateActionBadge>
               }
               name={'consentTemplates'}
               label={consentTemplateActionTranslationKeys.label}
               order={VisitActionBarOrder.ConsentTemplates}
               onClick={openModal}
            />
         )}
      </ConsentTemplateModalOpener>
   );
};
